import CircleNumber from 'components/CircleNumber/CircleNumber';
import { IListProps } from 'components/List/List';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  title: string;
  myIndex: number;
  color: string;
  activeColor: string;
}

type Props = IProps & IListProps;

export const ListMenuItem: React.SFC<Props> = props => {
  const changeList = () => props.changeItem(props.myIndex);
  const isActive = props.myIndex === props.index;
  return (
    <Container isActive={isActive} onClick={changeList}>
      <Cicle
        color={props.color}
        activeColor={props.activeColor}
        isActive={isActive}
      >
        {props.myIndex + 1}
      </Cicle>
      <Title isActive={isActive}>{props.title}</Title>
    </Container>
  );
};

interface IActive {
  isActive: boolean;
}

const Title = styled.span<IActive>`
  font-size: 16px;
  text-transform: uppercase;
  font-weight: ${p => p.isActive && 'bold'};
`;

const Cicle = styled(CircleNumber)`
  margin-right: 30px;
  flex: 0 0 30px;
`;

const Container = styled.div<IActive>`
  cursor: pointer;
  padding: 10px 0;
  display: flex;
  align-items: center;
`;

export default ListMenuItem;



// WEBPACK FOOTER //
// ./src/components/ListMenuItem/ListMenuItem.tsx